import Swiper, { EffectFade } from 'swiper'

Swiper.use([EffectFade])

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init)
} else {
  init()
}

function init() {
  const callback = document.querySelector(
    '[data-formCallback], [data-callback]'
  );

  if (!callback) return;

  const callbackSlider = callback.querySelector('[data-callback-slider]');
  const nextButtons = callback.querySelectorAll('[data-callback-next]');
  const previousButton = callback.querySelector('[data-callback-previous]');

  const callbackSliderOptions = {
    speed: 450,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    allowTouchMove: false,
  };

  const callbackSliderInit = new Swiper(callbackSlider, callbackSliderOptions);

  nextButtons.forEach((nextButton) => {
    nextButton.addEventListener('click', () => {
      callbackSliderInit.slideNext();
    });
  });

  previousButton.addEventListener('click', () => {
    callbackSliderInit.slidePrev();
  });

  updateTabindices(callbackSliderInit);

  callbackSliderInit.on('slideChange', () => {
    if (callbackSliderInit.activeIndex > 0) {
      previousButton.classList.add('Callback-previous--is-visible');
    } else {
      previousButton.classList.remove('Callback-previous--is-visible');
    }
    updateTabindices(callbackSliderInit);
  });

  sliderSteps(callback);
  sliderErrors(callbackSliderInit);
  updateTabindices(callbackSliderInit);
}

function updateTabindices(slider) {
  const callbackContainer = slider.el.closest(
    '[data-formCallback], [data-callback]'
  );
  const previousButton = callbackContainer
    ? callbackContainer.querySelector('[data-callback-previous]')
    : null;

  slider.slides.forEach((slide, index) => {
    const focusables = slide.querySelectorAll('input, select, button');
    const isActive = index === slider.activeIndex;

    if (isActive) {
      slide.removeAttribute('inert');
      slide.setAttribute('aria-hidden', 'false');
    } else {
      slide.setAttribute('inert', '');
      slide.setAttribute('aria-hidden', 'true');
    }

    focusables.forEach((el) => {
      el.setAttribute('tabindex', isActive && !el.disabled ? '0' : '-1');
    });
  });

  if (previousButton) {
    previousButton.setAttribute(
      'tabindex',
      slider.activeIndex > 0 ? '0' : '-1'
    );
  }
}

function sliderSteps(sliderContainer) {
  const slides = sliderContainer.querySelectorAll('.swiper-slide')

  slides.forEach((slide, index) => {
    const input = slide.querySelector('input, select');
    const button = slide.querySelector('button');

    if (!input || !button) return;

    if (!input.value.length) {
      button.setAttribute('disabled', '');
      button.setAttribute('tabindex', '-1');
    } else {
      button.removeAttribute('disabled');
      button.setAttribute('tabindex', '0');
    }

    input.addEventListener('input', function () {
      if (this.value.length) {
        button.removeAttribute('disabled');
        button.setAttribute('tabindex', '0');
      } else {
        button.setAttribute('disabled', '');
        button.setAttribute('tabindex', '-1');
      }
    });

    // Manage the focus on the keyboard: when you do Tab on the last input,
    // ensure that the submit button is accessible
    if (index === slides.length - 1) {
      input.addEventListener('keydown', function (e) {
        if (
          e.key === 'Tab' &&
          !e.shiftKey &&
          this.value.length &&
          !button.disabled
        ) {
          e.preventDefault();
          button.focus();
        }
      });
    }

    if (index < slides.length - 1) {
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && this.value.length && !button.disabled) {
          e.preventDefault();
          button.click();
        }
      });
    }
  });
}

function sliderErrors(slider) {
  const slides = slider.slides

  for (let index = 0; index < slides.length; index++) {
    if (slides[index].hasAttribute('data-field-error')) {
      slider.slideTo(index, 0, false)
      break
    }
  }
}
